module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "10",
      "offset-md": "1"
    }
  }, [_c('b-row', [_c('b-col', [_c('back-button', {
    attrs: {
      "returnUrl": _vm.returnUrl
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "offset-md": "5"
    }
  }, [_c('f7-button', {
    staticClass: "showLargeScreenOnly milkyBlockBlack new-button-white",
    on: {
      "click": function($event) {
        return _vm.onRefresh()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "refresh"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fab-label"
  }, [_vm._v(_vm._s(_vm.$t('common.rfrsh')))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel21 panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "content-block labelAccordionForm"
  }, [_c('f7-icon', {
    staticClass: "formIcon",
    attrs: {
      "fa": "address-book"
    }
  }), _vm._v(" "), (_vm.user.type === '1') ? _c('span', [_vm._v(_vm._s(_vm.$t('administration.company_details')))]) : _vm._e(), _vm._v(" "), (_vm.user.type === '2') ? _c('span', [_vm._v(_vm._s(_vm.$t('administration.user_details')))]) : _vm._e()], 1)]), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-start"
  }, [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.user_id'),
      "inputValue": _vm.user.id
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.user_login'),
      "inputValue": _vm.user.login
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.account_active'),
      "inputValue": _vm.translateActive(_vm.user.active)
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.account_date_activation'),
      "inputValue": _vm.user.DateActivation
    }
  })], 1), _vm._v(" "), (_vm.user.type == 1) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.company_name'),
      "inputValue": _vm.user.Name
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.type == 2) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.user_firstname_name'),
      "inputValue": _vm.user.Name
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.type == 1) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.company_number'),
      "inputValue": _vm.user.Identifier
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.type == 2) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.user_identifier'),
      "inputValue": _vm.user.Identifier
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.account_email_reference'),
      "inputValue": _vm.user.EmailReference
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.account_address'),
      "inputValue": _vm.user.Address
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.account_city'),
      "inputValue": _vm.user.City
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.account_zip_code'),
      "inputValue": _vm.user.ZipCode
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.country'),
      "inputValue": _vm.user.Country
    }
  })], 1), _vm._v(" "), (_vm.user.type == 1) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.account_legal_form'),
      "inputValue": _vm.user.LegalForm
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.type == 1) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.account_amount_of_capital'),
      "inputValue": _vm.user.AmountOfCapital
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.type == 1) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.account_identifier_tva'),
      "inputValue": _vm.user.IdentifierTVA
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.account_phone_number'),
      "inputValue": _vm.user.PhoneNumber
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.account_api_endpoint'),
      "inputValue": _vm.user.APIEndpoint
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.account_type'),
      "inputValue": _vm.user.AccountType
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('administration.user_account_type'),
      "inputValue": _vm.user.type
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "form-group justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "md": "5",
      "xl": "3",
      "offset-xl": "4"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "disabled": !_vm.canResetUserAccountPassword()
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('administration.reset_password')))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "5",
      "xl": "3"
    }
  }, [(_vm.user.active == 0) ? _c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "disabled": !_vm.canDeactivateUserAccount()
    },
    on: {
      "click": function($event) {
        return _vm.activate('1')
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "lock_open"
    }
  }), _vm._v(" "), (_vm.user.type === '1') ? _c('span', [_vm._v(_vm._s(_vm.$t('administration.company_activate')))]) : _vm._e(), _vm._v(" "), (_vm.user.type === '2') ? _c('span', [_vm._v(_vm._s(_vm.$t('administration.user_activate')))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.user.active > 0) ? _c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "disabled": !_vm.canDeactivateUserAccount()
    },
    on: {
      "click": function($event) {
        return _vm.activate('0')
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "lock"
    }
  }), _vm._v(" "), (_vm.user.type === '1') ? _c('span', [_vm._v(_vm._s(_vm.$t('administration.company_deactivate')))]) : _vm._e(), _vm._v(" "), (_vm.user.type === '2') ? _c('span', [_vm._v(_vm._s(_vm.$t('administration.user_deactivate')))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "5",
      "xl": "3",
      "offset-xl": "4"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "disabled": !_vm.canEditUserAccount()
    },
    on: {
      "click": _vm.editUserAccount
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "edit"
    }
  }), _vm._v(" "), (_vm.user.type === '1') ? _c('span', [_vm._v(_vm._s(_vm.$t('administration.company_edit')))]) : _vm._e(), _vm._v(" "), (_vm.user.type === '2') ? _c('span', [_vm._v(_vm._s(_vm.$t('administration.user_edit')))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "5",
      "xl": "3"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "disabled": !_vm.canRemoveUserAccount()
    },
    on: {
      "click": _vm.removeUserAccount
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "close_round"
    }
  }), _vm._v(" "), (_vm.user.type === '1') ? _c('span', [_vm._v(_vm._s(_vm.$t('administration.company_delete')))]) : _vm._e(), _vm._v(" "), (_vm.user.type === '2') ? _c('span', [_vm._v(_vm._s(_vm.$t('administration.user_delete')))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6a0208f0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a0208f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/administration/AccountsListDetailPage.vue
// module id = 2387
// module chunks = 2